import { render, staticRenderFns } from "./AttributeOptions.vue?vue&type=template&id=21b39952"
import script from "./AttributeOptions.vue?vue&type=script&lang=js"
export * from "./AttributeOptions.vue?vue&type=script&lang=js"
import style0 from "./AttributeOptions.vue?vue&type=style&index=0&id=21b39952&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports